<div class="container row justify-content-center form-layout" #stepOne>
  <h1 class="sr-only">Application Form</h1> 
  <div class="card mb-4 col-7 card-layout" [ngStyle]="formStyles"
    *ngFor="let subform of subForm?.subform_sections;let i=index"
    [hidden]="subform.section_name == 'TAF Creation' && subForm?.subform_name != 'Review Form'"
    tabindex="0"
    [attr.aria-labelledby]="'sectionHeading' + i"
    >
    <div class="card-body">
      <h2 class="card-title form-subtitle"
          [attr.aria-label]="subform.section_name"
          [attr.id]="'sectionHeading' + i">
          {{ subform.section_name }}
      </h2>
      <form [formGroup]="dynFormGroup">
        <fieldset>
          <legend class="sr-only">{{ subform.section_name }}</legend>
        <div class="container row">
          <ng-container *ngFor="let fields of subform.fields">
            <div *ngIf="fields.configuration" formControlGrid [formField]="fields" style="padding: 12px;">
              <ng-container renderFormControl [formField]="fields" [formGroup]="dynFormGroup" [requiredStarColor]="fields.validation_star_styles">
              </ng-container>
              <span
              *ngIf="
                (dynFormGroup.controls[fields['control_name']].touched) &&
                dynFormGroup.controls[fields['control_name']].errors
              "
            >
              <!-- This Field has errors. -->
              <ng-container *ngFor="let validation of fields.validators">
                <span
                  *ngIf="
                    dynFormGroup.controls[fields['control_name']].errors![
                      validation.type
                    ]
                  "
                      class="error-text"
                      role="alert"
                >
                  {{ validation.message }}
                </span>
              </ng-container>
            </span>
            </div>
            
          </ng-container>
        </div>
        </fieldset>
      </form>
    </div>
  </div>
</div>
